<template>
    <span>
        <svg
            v-if="name == 'like'"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 22"
            width="25px" height="22px">
            <path fill-rule="evenodd"
            d="M12.494,4.805 C9.258,-2.824 0.059,-1.043 -0.002,7.811 C-0.037,12.930 6.210,19.064 12.513,21.998 C19.445,18.960 25.036,12.843 25.001,7.757 C24.939,-1.119 15.581,-2.519 12.494,4.805 Z"/>
        </svg>
   </span>
</template>

<script>
    export default {
        name: 'SvgSprite',
        props: {
            name: {
                type: String,
                required: true
            }
        }
    }
</script>